const HTML_TAGS = [
  'a',
  'abbr',
  // 'acronym',
  'address',
  // 'applet',
  'area',
  'article',
  'aside',
  'audio',
  'b',
  // 'base',
  // 'basefont',
  'bdi',
  'bdo',
  'big',
  'blockquote',
  'body',
  'br',
  'button',
  'canvas',
  'caption',
  // 'center',
  'cite',
  'code',
  'col',
  'colgroup',
  'data',
  'datalist',
  'dd',
  'del',
  'details',
  'dfn',
  'dialog',
  // 'dir',
  'div',
  'dl',
  'dt',
  'em',
  'embed',
  'fieldset',
  'figcaption',
  'figure',
  // 'font',
  'footer',
  'form',
  // 'frame',
  // 'frameset',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  // 'head',
  'header',
  'hr',
  'html',
  'i',
  'iframe',
  'img',
  'input',
  'ins',
  'kbd',
  'label',
  'legend',
  'li',
  // 'link',
  'main',
  'map',
  'mark',
  // 'meta',
  'meter',
  'nav',
  // 'noframes',
  // 'noscript',
  'object',
  'ol',
  'optgroup',
  'option',
  'output',
  'p',
  // 'param',
  'picture',
  'pre',
  'progress',
  'q',
  'rp',
  'rt',
  'ruby',
  's',
  'samp',
  // 'script',
  'section',
  'select',
  'small',
  'source',
  'span',
  // 'strike',
  'strong',
  // 'style',
  'sub',
  'summary',
  'sup',
  'svg',
  'table',
  'tbody',
  'td',
  'template',
  'textarea',
  'tfoot',
  'th',
  'thead',
  'time',
  // 'title',
  'tr',
  'track',
  // 'tt',
  'u',
  'ul',
  'var',
  'video',
  'wbr',
] as const

const HTML_TEXT_TAGS = [
  'abbr',
  'b',
  'bdi',
  'bdo',
  'big',
  'blockquote',
  'cite',
  'code',
  'dl',
  'dt',
  'em',
  'figcaption',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'i',
  'ins',
  'kbd',
  'label',
  'legend',
  'li',
  'p',
  'pre',
  'q',
  'rp',
  'rt',
  's',
  'small',
  'span',
  'strong',
  'sub',
  'summary',
  'sup',
  'time',
  'u',
] as const

export type HTMLTags = (typeof HTML_TAGS)[number]

export type HTMLTextTags = (typeof HTML_TEXT_TAGS)[number]

export { HTML_TAGS, HTML_TEXT_TAGS }
